























































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import GenericAdd from "@/core/Generics/GenericAdd";
import ResearchCenter from "@/models/research/ResearchCenter/reseachCenter.model";
import ProvinciaMunicipio from "@/components/provinceAndMunicipality/provinceMunicipality.vue";
import BaseSelectPerson from "@/components/base/baseSelectPerson/baseSelectPerson.vue";
import { InstitutionType } from "@/enums/InstitutionType";

@Component({
  components: {
    ProvinciaMunicipio,
    BaseSelectPerson,
  },
})
export default class ResearchCenterAdd extends GenericAdd<ResearchCenter> {
  constructor() {
    super();
    this.controller = "ResearchCenters";
    this.model = new ResearchCenter();
  }
  imageResult: any = null;
  institutionType = InstitutionType;

  get getImage() {
    if (this.imageResult) return this.imageResult;
    return false;
  }

  changeImage() {
    var self = this;
    var reader = new FileReader();
    reader.readAsArrayBuffer(this.model.file);
    this.imageResult = URL.createObjectURL(this.model.file);
    reader.onloadend = function (evt: any) {
      if (evt.target.readyState == FileReader.DONE) {
        var arrayBuffer = evt.target.result,
          array = new Uint8Array(arrayBuffer);
        for (var i = 0; i < array.length; i++) {
          self.model.image.push(array[i]);
        }
      }
    };
  }
  protected async add() {
    try {
      
      this.saving = true;
      let result = await this.repository.create(this.model);
      this.saving = false;
      this.$emit("add", result);
      this.clean();
      this.operationSuccess();

      if (this.exitOnSave) this.confirmedCancel();
    } catch (errors) {
      this.operationFailedErrors(errors);
    } finally {
      this.saving = false;
    }
  }
}
